module.exports = __webpack_public_path__ + "static/media/Screen Shot 2022-05-30 at 9.49.32 PM.25d933d6.png";